import { Color3 } from "@babylonjs/core/Maths/math.color";
import { DynamicTexture } from "@babylonjs/core/Materials/Textures/dynamicTexture";
import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { CreateLineSystem } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { MeasureInteractors } from '../tool/interactors';
import { GeoUtils } from "./geo/GeoUtils";
import { MEASURE_ELEMENT_CLASSID } from "./io/Types";
import { VisibilityMode } from "../RoomManager";
import { Util } from "../utils/Util";
import { ElementCategory, SceneElement, UndoOperation } from '@egr/wcf/modules/core/mdl';
import { serializeVector2, deserializeVector2 } from '@egr/wcf/modules/core/io';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { PropertyValue, BoolProperty, PropertyChangedResult, LengthProperty, StringProperty } from '@egr/wcf/modules/core/prop';
import { ShadowGenerator } from '@egr/wcf/modules/core/rendering/ShadowGenerator';
import { eq, clamp, roundTo, radToDeg } from '@egr/wcf/modules/utils/math';
import { signedAngleBetweenVectors2, VECTOR2_X, VECTOR3_ZERO, perpendicularVector2 } from '@egr/wcf/modules/core/utils/MathUtils';
import { toLocaleLengthString } from '@egr/wcf/modules/utils/number';
import { updateFrozenWorldMatrix, resizeInViewSpace } from '@egr/wcf/modules/core/utils/MeshUtils';
export var MeasureEnding;
(function (MeasureEnding) {
    MeasureEnding[MeasureEnding["Start"] = 0] = "Start";
    MeasureEnding[MeasureEnding["End"] = 1] = "End";
})(MeasureEnding || (MeasureEnding = {}));
export var MeasureSide;
(function (MeasureSide) {
    MeasureSide[MeasureSide["Left"] = 0] = "Left";
    MeasureSide[MeasureSide["Right"] = 1] = "Right";
})(MeasureSide || (MeasureSide = {}));
export class Measure extends SceneElement {
    constructor(pRoomManager) {
        super(pRoomManager.app.model, new TransformNode("room:Measure", pRoomManager.app.model.scene));
        this.mTextScale = 100;
        this.onCameraRender = () => {
            this.getScaleFactor();
            this.updateTextNode();
        };
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mInteractors = new MeasureInteractors(this.mRoomManager, this);
        this.mId = this.mRoomManager._getNextWallId();
        this.mStart = new Vector2(0, 0);
        this.mEnd = new Vector2(1, 0);
        this.mScaleFactor = 1;
        this.mLineOffset = 1;
        this.mLineOffsetFac = 1;
        this.mEdges = new Array();
        this.mEdges.push(Vector2.Zero(), Vector2.Zero(), Vector2.Zero(), Vector2.Zero());
        this.mUnCutEdges = new Array();
        this.mUnCutEdges.push(Vector2.Zero(), Vector2.Zero(), Vector2.Zero(), Vector2.Zero());
        if (this.mNode != null)
            this.mNode.freezeWorldMatrix();
        this.m2dMeshes = new Array();
        this.m3dMeshes = new Array();
        this.m3dNeedsUpdate = false;
        this.mVisible = true;
        this.mTextOnTop = true;
        this.mVM_IsHidden = false;
        this.mTextNode = new TransformNode("MeasureText", this.mScene);
        // this.mTextNode.parent = this.mNode;
        this.mScaleNode = new TransformNode("MeasureScaleNode", this.mScene);
        this.mScaleNode.parent = this.mNode;
        this.mTransformMeasureLength = 0;
        this.mHandleTansformationChange = true;
        this.mPendingTransformMatrix = null;
        this.mFont = this.mRoomManager.app.theme.fontFamily;
        this.mFontSize = 70;
        this.mText = "";
        this.mTextColor = "#000000";
        this.mShowAlternativText = false;
        this.mOutputplaneTexture = new DynamicTexture("dimension_textTexture", { width: 1,
            height: 1
        }, this.mScene, false);
        this.mOutputplaneTexture.hasAlpha = true;
        //text material
        this.mTextMaterial = new StandardMaterial("", this.mScene);
        this.mTextMaterial.diffuseColor = Color3.White();
        this.mTextMaterial.emissiveColor = Color3.White();
        this.mTextMaterial.disableLighting = true;
        this.mTextMaterial.diffuseTexture = this.mOutputplaneTexture;
        this.mTextMaterial.backFaceCulling = false;
        this.mTextMaterial.freeze();
        this.mPW = 0;
        this.mPH = 0;
        this.setView();
    }
    get category() {
        return (ElementCategory.FloorPlan);
    }
    get id() {
        return (this.mId);
    }
    get startPoint() {
        return (this.mStart);
    }
    get endPoint() {
        return (this.mEnd);
    }
    get measureDirection() {
        return ((this.mEnd.subtract(this.mStart)).normalize());
    }
    get type() {
        return ("DimensionLine");
    }
    get isVisible() {
        return (this.mVisible);
    }
    get isVMHidden() {
        return (this.mVM_IsHidden);
    }
    get TextOnTop() {
        return (this.mTextOnTop);
    }
    get TextPosition() {
        return (this.mTextNode.position);
    }
    get isLableLength() {
        return (!this.mShowAlternativText);
    }
    get AlternativeText() {
        return (this.mText);
    }
    get LineOffset() {
        return (this.mLineOffset);
    }
    set enableTextNode(pVal) {
        this.mTextNode.setEnabled(pVal);
    }
    canTranslate() {
        let tRes = false;
        if (this.isSelected && this.mRoomManager.app.model.selection.length > 1)
            tRes = true;
        return (tRes);
    }
    canRotate() {
        let tRes = false;
        if (this.isSelected && this.mRoomManager.app.model.selection.length > 1)
            tRes = true;
        return (tRes);
    }
    showInteractors(pShow) {
        this.mInteractors.showInteractors(pShow);
    }
    hideText() {
        if (this.mOutputPlane != null) {
            this.mOutputPlane.visibility = 0;
        }
        if (this.mOutputPlane3d != null) {
            this.mOutputPlane3d.visibility = 0;
        }
        this.mVM_IsHidden = true;
    }
    showText() {
        if (this.mOutputPlane != null) {
            this.mOutputPlane.visibility = 1;
        }
        if (this.mOutputPlane3d != null) {
            this.mOutputPlane3d.visibility = 1;
        }
        this.mVM_IsHidden = false;
    }
    dispose() {
        this.mOutputPlane.dispose();
        this.mOutputPlane3d.dispose();
        super.dispose();
        this.mTextNode.dispose();
        this.mScaleNode.dispose();
        this.mInteractors.dispose();
        this.mOutputplaneTexture.dispose();
        this.mTextMaterial.dispose();
        let tView = this.mRoomManager.view;
        if (tView != null) {
            tView = tView;
            tView.cameraControl.eventCameraChanged.removeListener(this.onCameraRender);
            this.mRoomManager.app.model.scene.onBeforeCameraRenderObservable.removeCallback(this.onCameraRender);
        }
    }
    clone(pNewParent) {
        let tClone = new Measure(this.mRoomManager);
        tClone.setStartPoint(this.mStart.clone());
        tClone.setEndPoint(this.mEnd.clone());
        tClone.node.parent = pNewParent != null ? pNewParent : null;
        tClone.copyDataFrom(this);
        tClone.updateGeometry();
        tClone.eventAdded.addListener(() => tClone.afterClone());
        return (tClone);
    }
    afterClone() {
        let tcurrPos = this.node.position.clone();
        let tDir = this.measureDirection;
        let tLength = this.getMeasureLength();
        this.setStartPoint(Util.to2d(tcurrPos));
        this.setEndPoint(this.startPoint.add(tDir.scale(tLength)));
    }
    removeMeasure() {
        if (this.mOutputPlane != null)
            this.mOutputPlane.dispose();
        if (this.mOutputPlane3d != null)
            this.mOutputPlane3d.dispose();
        if (this.mTextNode != null)
            this.mTextNode.dispose();
        if (this.mPickPlane != null)
            this.mPickPlane.dispose();
        if (this.mPickPlaneS != null)
            this.mPickPlaneS.dispose();
        if (this.mPickPlaneE != null)
            this.mPickPlaneE.dispose();
        if (this.mPickPlaneT != null)
            this.mPickPlaneT.dispose();
    }
    saveUndoData(pOperation) {
        return (this._saveUndoData());
    }
    loadUndoData(pOperation, pUndoData) {
        this._loadUndoData(pUndoData);
        if (pOperation === UndoOperation.Transform)
            this.mRoomManager._removeTransformedElement(this);
    }
    isSelectionHighlightEnabled() {
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length !== 1)
            return (true);
        return (false);
    }
    getSelectionHighlightBoundingBox() {
        if (this.mRoomManager.visibilityMode === VisibilityMode.Show2d) {
            let tBounds = this.boundingBox.clone();
            tBounds.max.y = 0.001;
            return (tBounds);
        }
        return (this.boundingBox);
    }
    getProperties() {
        let tPromise = super.getProperties().then((pProperties) => {
            let tProperties = pProperties;
            if (tProperties == null)
                tProperties = new Array();
            //text label choice (length, alternativ text)
            let tLabelChoice = new Array();
            for (let tYesNo of this.mRoomManager._YesNo)
                tLabelChoice.push(this.mRoomManager._getMeasureTextChoicePropValue(tYesNo));
            //change text label
            let tBlindProp = new BoolProperty(this, Measure.PROP_KEY_TEXTCHOICE, this.mRoomManager.resources.propertyTextDisplay);
            tBlindProp.choiceList = true;
            tBlindProp.getChoices = () => Promise.resolve(tLabelChoice);
            tBlindProp.getValue = () => this.mRoomManager._getMeasureTextChoicePropValue(this.mShowAlternativText);
            tBlindProp.setValue = (pValue) => {
                if (pValue != null) {
                    let tValue = BoolProperty.ConvertValueToBool(pValue);
                    if (tValue != null)
                        this.switchTextLabel(tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tBlindProp);
            //length
            let tLengthProp = new LengthProperty(this, Measure.PROP_KEY_LENGTH, this.mRoomManager.resources.propertyLength);
            tLengthProp.getValue = () => new PropertyValue(this.getMeasureLength());
            tLengthProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null && this.setLength(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tLengthProp);
            //line distance
            let tLineDistanceProp = new LengthProperty(this, Measure.PROP_KEY_LINEDISTANCE, this.mRoomManager.resources.propertyDistance);
            tLineDistanceProp.getValue = () => new PropertyValue(this.mLineOffset - 0.1);
            tLineDistanceProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setLineOffset(tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tLineDistanceProp);
            //alternative text
            let tTextProp = new StringProperty(this, Measure.PROP_KEY_TEXT, this.mRoomManager.resources.propertyAlternativeText);
            tTextProp.getValue = () => new PropertyValue(this.mText);
            tTextProp.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null && this.setText(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tTextProp.editable = this.mShowAlternativText;
            tProperties.push(tTextProp);
            //color
            let tColorChoices = new Array();
            for (let tCol of this.mRoomManager._wallColors)
                tColorChoices.push(this.mRoomManager._getWallColorPropValue(tCol));
            //text color
            let tTextColorProp = new StringProperty(this, Measure.PROP_KEY_COLOR, this.mRoomManager.resources.propertyColor);
            tTextColorProp.choiceList = true;
            tTextColorProp.getChoices = () => Promise.resolve(tColorChoices);
            tTextColorProp.getValue = () => this.mRoomManager._getWallColorPropValue(this.mTextColor);
            tTextColorProp.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null && this.setTextColor(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tTextColorProp);
            return (tProperties);
        });
        return (tPromise);
    }
    serialize(pContext) {
        let tIOMeasure = {};
        tIOMeasure.classId = MEASURE_ELEMENT_CLASSID;
        tIOMeasure.id = this.mId;
        tIOMeasure.start = serializeVector2(this.mStart);
        tIOMeasure.end = serializeVector2(this.mEnd);
        tIOMeasure.lineOffset = this.mLineOffset;
        return (tIOMeasure);
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        let child = pDocument.createElement("dummy"); //dummy node definition for further use
        // wall child
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Dimension" });
        let twallNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, twallNode, "category", "Other", null);
        // start
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.startPoint.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: "0" });
        tAttribsList.push({ qualifiedName: "z", value: (-this.startPoint.y).toString() });
        Util._xmlAddChildNode(pDocument, twallNode, "start", "", tAttribsList);
        // end
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.endPoint.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: "0" });
        tAttribsList.push({ qualifiedName: "z", value: (-this.endPoint.y).toString() });
        Util._xmlAddChildNode(pDocument, twallNode, "end", "", tAttribsList);
        // text override
        Util._xmlAddChildNode(pDocument, twallNode, "textOverride", this.mText, null);
        // color
        tAttribsList = [];
        if (this.mTextColor.trim() != '') {
            let tcolL = Util.hexToRGB(this.mTextColor);
            tAttribsList.push({ qualifiedName: "r", value: tcolL.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolL.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolL.b.toString() });
            Util._xmlAddChildNode(pDocument, twallNode, "color", "", tAttribsList);
        }
    }
    updateGeometry() {
        if (!this.isInScene())
            return;
        this.updateTransformMatrix();
        this.update2dGeometry();
        this.update3dGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    setPickPlanePosition() {
        if (this.mPickPlaneT == null || this.mOutputPlane == null)
            return;
        let tWM = this.mNode.getWorldMatrix().getRotationMatrix();
        let tTextDiff = this.mOutputPlane.absolutePosition.subtract(this.mNode.position);
        //tTextDiff.addInPlace(to3d(this.measureDirection.scale(this.getMeasureLength())));
        tTextDiff.addInPlace(Util.to3d(this.measureDirection.scale(10)));
        let tnormal = Vector3.TransformCoordinates(tTextDiff, tWM);
        this.mPickPlaneT.position.x = tnormal.x;
        this.mPickPlaneT.position.z = tnormal.z;
    }
    setStartPoint(pPoint) {
        if (Util.vectorEquals2(pPoint, this.mStart) || Util.vectorEquals2(pPoint, this.mEnd))
            return;
        this.mStart.copyFrom(pPoint);
        this.updateGeometry();
        this.updateTextNode();
    }
    setEndPoint(pPoint) {
        if (Util.vectorEquals2(pPoint, this.mEnd) || Util.vectorEquals2(pPoint, this.mStart))
            return;
        this.mEnd.copyFrom(pPoint);
        this.updateGeometry();
        this.updateTextNode();
    }
    changeMeasurePoint() {
        let tstart = this.mStart.clone();
        let tend = this.mEnd.clone();
        this.mStart.copyFrom(tend);
        this.mEnd.copyFrom(tstart);
        this.updateGeometry();
    }
    setLineOffset(pValue, pUpdate = true) {
        if (eq(pValue, this.mLineOffset - 0.1))
            return;
        this.mLineOffset = clamp(pValue, -10, 10) + 0.1;
        this.mLineOffsetFac = this.mLineOffset > 0 ? 1 : -1;
        if (pUpdate) {
            this.updateGeometry();
        }
        this.notifyChange(ElementChangedFlags.PropertyValues);
        return;
    }
    moveMeasure(pDirection) {
        this.mStart.addInPlace(pDirection);
        this.mEnd.addInPlace(pDirection);
        this.updateGeometry();
    }
    setLength(pLength) {
        if (eq(pLength, this.getMeasureLength()))
            return (false);
        let tDeltaLength = pLength - this.getMeasureLength();
        let tV1 = this.startPoint;
        let tV2 = this.endPoint;
        let tDir = tV2.subtract(tV1).normalize();
        let tV = tV1.add(tDir.scale(this.getMeasureLength() + tDeltaLength));
        this.setEndPoint(tV);
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        return (true);
    }
    setText(pText) {
        if (pText == this.mText)
            return (false);
        this.mText = pText;
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        return (true);
    }
    setVisibility(pVisible) {
        if (this.mVM_IsHidden) {
            return;
        }
        this.mNode.setEnabled(pVisible);
        this.mTextNode.setEnabled(pVisible);
    }
    getMeasureAngle() {
        let tVDir = this.mEnd.subtract(this.mStart).normalize();
        let tResAngle = signedAngleBetweenVectors2(VECTOR2_X, tVDir);
        let tAngle = roundTo(radToDeg(signedAngleBetweenVectors2(VECTOR2_X, tVDir)), 0);
        if (tAngle > -90.0 && tAngle < 90) {
            this.mTextOnTop = true;
        }
        else {
            this.mTextOnTop = false;
        }
        return (tResAngle);
    }
    getMeasureLength() {
        return (Vector2.Distance(this.mStart, this.mEnd));
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    get _edges() {
        return (this.mEdges);
    }
    /** @internal */
    _saveUndoData() {
        let tData = {};
        tData.start = this.mStart.clone();
        tData.end = this.mEnd.clone();
        return (tData);
    }
    /** @internal */
    _loadUndoData(pData) {
        if (pData == null)
            return;
        this.mStart = pData.start.clone();
        this.mEnd = pData.end.clone();
        this.updateGeometry();
    }
    /** @internal */
    _interactionFinished() {
        if (this.m3dNeedsUpdate) {
            this.update3dGeometry();
        }
    }
    /** @internal */
    _finishLoading(pIOMeasure) {
        if (pIOMeasure == null)
            return;
    }
    /** @internal */
    _updateVisibility() {
        //update selection bounds
        this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    /** @internal */
    _finishTransformation() {
        if (this.mPendingTransformMatrix == null)
            return;
        //transfom start and end
        this.mStart = Util.to2d(Vector3.TransformCoordinates(VECTOR3_ZERO, this.mPendingTransformMatrix));
        this.mEnd = Util.to2d(Vector3.TransformCoordinates(new Vector3(this.mTransformMeasureLength, 0, 0), this.mPendingTransformMatrix));
        this.mPendingTransformMatrix = null;
        this.mTextNode.setEnabled(true);
        this.updateEdges();
        this.updateGeometry();
        this.setPickPlanePosition();
    }
    /** @internal */
    static _registerClass(pRoomManager) {
        pRoomManager.app.model.registerElementLoader(MEASURE_ELEMENT_CLASSID, (pApp, pContext, pIOElement) => {
            return (Measure.deserialize(pRoomManager, pContext, pIOElement));
        });
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleImmediateChanges() {
        super.handleImmediateChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Added))
            this.mRoomManager._addMeasure(this);
        if (this.wasFlagChanged(ElementChangedFlags.Removed)) {
            this.mRoomManager._removeMeasure(this);
        }
    }
    handleDelayedChanges() {
        super.handleDelayedChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Transformation) && this.mHandleTansformationChange) {
            if (this.mRoomManager._transformationStarted()) {
                this.mPendingTransformMatrix = this.transform.clone();
                this.mTransformMeasureLength = this.getMeasureLength();
                this.mRoomManager._addTransformedElement(this);
            }
            else
                this.updateTransformMatrix(); // reset transform
        }
    }
    updateTransformMatrix() {
        let tMRot = Matrix.RotationY(-this.getMeasureAngle());
        let tMTrans = Matrix.Translation(this.mStart.x, 0.0, this.mStart.y);
        this.mHandleTansformationChange = false;
        this.setTransform(tMRot.multiply(tMTrans));
        this.mHandleTansformationChange = true;
    }
    updateTextNode() {
        if (this.mVM_IsHidden) {
            return;
        }
        let tNodePos = this.node.position.clone();
        let tdir_perp = Util.to3d(perpendicularVector2(this.measureDirection));
        tNodePos.subtractInPlace(tdir_perp.scale(this.mLineOffset - (Measure.LINEENDOFFSET * this.mLineOffsetFac)));
        let tdir = this.measureDirection;
        let tlength = this.getMeasureLength();
        let tnewPos = tNodePos.add(Util.to3d(tdir.scale(tlength * 0.5)));
        this.mTextNode.setAbsolutePosition(tnewPos);
        updateFrozenWorldMatrix(this.mTextNode, true);
        if (this.mRoomManager.hoverView != null) {
            resizeInViewSpace(this.mRoomManager.hoverView, this.mTextNode, 0.1, Measure.TEXTSCALE);
            this.mTextNode.rotation = this.mNode.rotation;
        }
        this.updateEdges();
        this.mTextNode.rotationQuaternion = this.mNode.rotationQuaternion;
        this.mScaleNode.scaling.z = this.mTextNode.scaling.z;
        this.mScaleNode.position.y = 0;
        this.mOutputPlane.computeWorldMatrix(true);
        let tPP = this.mOutputPlane.getAbsolutePosition();
        tPP.y = 0.02;
        this.mOutputPlane.setAbsolutePosition(tPP);
        this.mOutputPlane3d.setAbsolutePosition(tPP);
        if (this.mPickPlane != null)
            this.mPickPlane.scaling.y = this.mTextNode.scaling.y;
        if (this.mPickPlaneS != null)
            this.mPickPlaneS.scaling.x = this.mTextNode.scaling.x;
        if (this.mPickPlaneE != null)
            this.mPickPlaneE.scaling.x = this.mTextNode.scaling.x;
        if (this.mRoomManager.view == null)
            return;
        this.getMeasureAngle();
    }
    getScaleFactor() {
        if (this.mRoomManager.hoverView == null)
            return;
        let tScaleFactor = Util.getViewScaleFactorOfNode(this.mRoomManager.hoverView, this.mTextNode, 0.1, Measure.TEXTSCALE);
        if (tScaleFactor == null)
            return;
        this.mScaleFactor = tScaleFactor;
    }
    updateEdges() {
        let tHT = 0.00001;
        let tAngle = this.getMeasureAngle();
        let tCosA = Math.cos(tAngle);
        let tSinA = Math.sin(tAngle);
        this.mEdges[0].set(this.mStart.x + (tHT * tSinA), this.mStart.y - (tHT * tCosA));
        this.mEdges[3].set(this.mStart.x - (tHT * tSinA), this.mStart.y + (tHT * tCosA));
        this.mEdges[1].set(this.mEnd.x + (tHT * tSinA), this.mEnd.y - (tHT * tCosA));
        this.mEdges[2].set(this.mEnd.x - (tHT * tSinA), this.mEnd.y + (tHT * tCosA));
        for (let i = 0; i < 4; ++i)
            this.mUnCutEdges[i].copyFrom(this.mEdges[i]);
    }
    setTextColor(pTextColor) {
        if (this.mTextColor == pTextColor)
            return (false);
        this.mTextColor = pTextColor;
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.endChange();
        return (true);
    }
    switchTextLabel(pEnableAlternativeText) {
        this.mShowAlternativText = pEnableAlternativeText;
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
        this.endChange();
    }
    wrapText(pContext, x, y, maxWidth, lineHeight) {
        let tText = "";
        if (!this.mShowAlternativText)
            tText = this.lengthToString(this.getMeasureLength()) + " " + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit);
        else
            tText = this.mText;
        let words = tText.split('#');
        let line = '';
        for (let n = 1; n <= words.length; n++) {
            let testLine = line + words[n - 1] + ' ';
            testLine = testLine.substring(0, 100);
            let tTScale = this.mTextScale / 100;
            let tdTy = this.mFontSize * tTScale * 1.25 * n - ((this.mFontSize * tTScale) / 3.2);
            let tFont = (this.mFontSize * tTScale) + "px " + this.mFont;
            pContext.getContext().fillStyle = 'white';
            pContext.clear();
            pContext.drawText(testLine, null, tdTy, tFont, this.mTextColor, "white");
            y += lineHeight;
        }
    }
    getMaxMeasureFromText(pText) {
        let tevalTexture = new DynamicTexture("dynamic texture", { width: 256, height: 256 }, null, true);
        let ttexContext = tevalTexture.getContext();
        ttexContext.font = (this.mFontSize * (this.mTextScale / 100)) + "px " + this.mFont;
        let tWords = pText.split('#');
        let tLine = '';
        let tTxtMeasure = {};
        tTxtMeasure.maxWidth = 0;
        tTxtMeasure.lineCount = tWords.length;
        for (let twrd of tWords) {
            let tTestLine = tLine + twrd + ' ';
            let tMetrics = ttexContext.measureText(tTestLine);
            tTxtMeasure.maxWidth = Math.max(tTxtMeasure.maxWidth, tMetrics.width);
        }
        tevalTexture.dispose();
        return (tTxtMeasure);
    }
    createText(p2d) {
        this.calcTextSize();
        //text node and plane
        let outputplane = CreatePlane("dimension_textPlane", { width: this.mPW, height: this.mPH }, this.mScene);
        outputplane.rotation.x = Math.PI / 2;
        outputplane.material = this.mTextMaterial;
        outputplane.parent = this.mTextNode;
        if (this.mTextOnTop)
            outputplane.position.z = 0.1;
        else {
            outputplane.position.z = -0.1;
            outputplane.rotation.z = Math.PI;
        }
        outputplane.isPickable = true;
        outputplane.renderingGroupId = 0;
        outputplane.alwaysSelectAsActiveMesh = true;
        if (p2d) {
            this.mOutputPlane = outputplane;
            this.m2dMeshes.push(outputplane);
        }
        else {
            this.mOutputPlane3d = outputplane;
            this.m3dMeshes.push(outputplane);
        }
        ShadowGenerator.disableMeshShadow(outputplane);
        this.wrapText(this.mOutputplaneTexture, 0, this.mFontSize, 2000, 100);
    }
    lengthToString(pValue, pAddUnit = false) {
        let tString = toLocaleLengthString(pValue, this.mRoomManager.app.i18n.locale, this.mRoomManager.app.i18n.lengthUnit, pAddUnit);
        return (tString != null ? tString : pValue.toString());
    }
    calcTextSize() {
        let tText = "";
        if (!this.mShowAlternativText)
            tText = this.lengthToString(this.getMeasureLength()) + " " + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit);
        else
            tText = this.mText;
        let tmaxTextureMeasures = this.getMaxMeasureFromText(tText);
        let tscaleNum = 356.887937;
        let tTW = tmaxTextureMeasures.maxWidth + (this.mFontSize * (this.mTextScale / 100));
        let tTH = tmaxTextureMeasures.lineCount * ((this.mFontSize * (this.mTextScale / 100)) * 1.25);
        this.mOutputplaneTexture.scaleTo(tTW, tTH);
        let tWC = 26.390625;
        let tLF = 5;
        let tD = (tmaxTextureMeasures.maxWidth / tWC) - 1;
        let tTS = (Math.log(tD * tLF) / Math.log(500)) + 0.37;
        if (tmaxTextureMeasures.maxWidth > tWC * 21)
            tTS = tTS * 0.96;
        if (tmaxTextureMeasures.maxWidth > tWC * 31)
            tTS = tTS * 0.94;
        if (tmaxTextureMeasures.maxWidth > tWC * 100)
            tTS = 1.15;
        this.mPW = tmaxTextureMeasures.maxWidth / (tscaleNum * tTS);
        this.mPH = (tmaxTextureMeasures.lineCount * (this.mFontSize * (this.mTextScale / 100))) / tscaleNum;
    }
    createLineSystem(p2d) {
        if (p2d)
            this.dispose2dMeshes();
        else
            this.dispose3dMeshes();
        let tLines = new Array();
        let tDir_perp = Util.to3d(perpendicularVector2(this.measureDirection));
        // main line
        let t_P1 = Util.to3d(this.mStart);
        let t_P2 = Util.to3d(this.mEnd);
        let t_P1r = this.mStart.add(this.measureDirection.scale(0.1));
        let t_P2r = this.mEnd.subtract(this.measureDirection.scale(0.1));
        let t_L1 = Util.to3d(t_P1r.subtract(Util.to2d(tDir_perp.scale(this.mLineOffset - (Measure.LINEENDOFFSET * this.mLineOffsetFac)))));
        let t_L2 = Util.to3d(t_P2r.subtract(Util.to2d(tDir_perp.scale(this.mLineOffset - (Measure.LINEENDOFFSET * this.mLineOffsetFac)))));
        // start/end line
        let t_P1L = t_P1.subtract(tDir_perp.scale(this.mLineOffset));
        let t_P2R = t_P2.subtract(tDir_perp.scale(this.mLineOffset));
        // transform points to local coord system
        Vector3.TransformCoordinatesToRef(t_L1, this.transformInverted, t_L1);
        Vector3.TransformCoordinatesToRef(t_L2, this.transformInverted, t_L2);
        Vector3.TransformCoordinatesToRef(t_P1, this.transformInverted, t_P1);
        Vector3.TransformCoordinatesToRef(t_P2, this.transformInverted, t_P2);
        Vector3.TransformCoordinatesToRef(t_P1L, this.transformInverted, t_P1L);
        Vector3.TransformCoordinatesToRef(t_P2R, this.transformInverted, t_P2R);
        // add lines to draw
        tLines.push([t_L1, t_L2]);
        tLines.push([t_P1, t_P1L]);
        tLines.push([t_P2, t_P2R]);
        let tLine = CreateLineSystem("", {
            lines: tLines,
            updatable: false,
            instance: null
        }, this.mScene);
        tLine.color = Color3.Black();
        tLine.isPickable = true;
        tLine.intersectionThreshold = 0;
        tLine.parent = this.mNode;
        tLine.position.y = 0.02;
        tLine.renderingGroupId = 0;
        ShadowGenerator.disableMeshShadow(tLine);
        if (p2d) {
            this.m2dMeshes.push(tLine);
        }
        else {
            this.m3dMeshes.push(tLine);
        }
        this.createLineArrows(p2d);
        this.createPickPlane(p2d);
    }
    createLineArrows(p2d) {
        const tW = 0.1;
        const tWH = 0.1 * 0.5;
        const tarrowD = 0.075;
        const tposRX = this.getMeasureLength() - tWH;
        const tposZ = this.mLineOffset - (Measure.LINEENDOFFSET * this.mLineOffsetFac);
        const tMat = this.mRoomManager.createColorMaterial("#000000");
        // arrows
        let tarrowL = GeoUtils.createTriangle(tW, tarrowD, this.mNode, this.mScene);
        if (tarrowL == null)
            return;
        tarrowL.position = new Vector3(tWH, 0.02, tposZ);
        tarrowL.isPickable = true;
        let tarrowR = tarrowL.clone("");
        tarrowR.scaling.x = -1;
        tarrowR.position = new Vector3(tposRX, 0.02, tposZ);
        tarrowR.isPickable = true;
        if (tMat != null) {
            tarrowL.material = tMat;
            tarrowR.material = tMat;
        }
        // add lines to draw
        let tLines = new Array();
        const tl1 = new Vector3(-tW * 0.5, 0, 0);
        const tl2 = new Vector3(tW * 0.5, 0, -tarrowD * 0.5);
        const tl3 = new Vector3(tW * 0.5, 0, tarrowD * 0.5);
        tLines.push([tl1, tl2]);
        tLines.push([tl2, tl3]);
        tLines.push([tl3, tl1]);
        let tLineArr1 = CreateLineSystem("", { lines: tLines, updatable: false, instance: null }, this.mScene);
        tLineArr1.color = Color3.White();
        tLineArr1.isPickable = true;
        tLineArr1.intersectionThreshold = 0;
        tLineArr1.parent = this.mNode;
        tLineArr1.position = new Vector3(tWH, 0.021, tposZ);
        tLineArr1.position.y = 0.02;
        tLineArr1.renderingGroupId = 0;
        let tLineArr2 = tLineArr1.clone("");
        tLineArr2.scaling.x = -1;
        tLineArr2.position = new Vector3(tposRX, 0.021, tposZ);
        tLineArr2.isPickable = true;
        if (p2d) {
            this.m2dMeshes.push(tarrowL, tarrowR);
            this.m2dMeshes.push(tLineArr1);
            this.m2dMeshes.push(tLineArr2);
        }
        else {
            this.m3dMeshes.push(tarrowL, tarrowR);
            this.m3dMeshes.push(tLineArr1);
            this.m3dMeshes.push(tLineArr2);
        }
        ShadowGenerator.disableMeshShadow(tarrowL);
        ShadowGenerator.disableMeshShadow(tarrowR);
        ShadowGenerator.disableMeshShadow(tLineArr1);
        ShadowGenerator.disableMeshShadow(tLineArr2);
    }
    createPickPlane(p2d) {
        //invisible geometry for picking
        if (this.mPickPlane != null) {
            this.mPickPlane.dispose();
            this.mPickPlane = null;
        }
        if (this.mPickPlaneS != null) {
            this.mPickPlaneS.dispose();
            this.mPickPlaneS = null;
        }
        if (this.mPickPlaneE != null) {
            this.mPickPlaneE.dispose();
            this.mPickPlaneE = null;
        }
        if (this.mPickPlaneT != null) {
            this.mPickPlaneT.dispose();
            this.mPickPlaneT = null;
        }
        this.mPickPlane = CreatePlane("", {
            width: this.getMeasureLength(),
            height: 0.25
        }, this.mScene);
        this.mPickPlane.isPickable = true;
        this.mPickPlane.position.x = this.getMeasureLength() * 0.5;
        this.mPickPlane.position.z = this.mLineOffset + (this.mLineOffsetFac) * (-0.1);
        this.mPickPlane.rotation.x = Math.PI / 2;
        this.mPickPlane.parent = this.mNode;
        this.mPickPlane.position.y = 0.022;
        this.mPickPlaneS = CreatePlane("", {
            width: 0.2,
            height: Math.abs(this.mLineOffset)
        }, this.mScene);
        this.mPickPlaneS.isPickable = true;
        this.mPickPlaneS.position.x = 0;
        this.mPickPlaneS.position.z = this.mLineOffset * 0.5;
        this.mPickPlaneS.rotation.x = Math.PI / 2;
        this.mPickPlaneS.parent = this.mNode;
        this.mPickPlaneS.position.y = 0.022;
        this.mPickPlaneE = CreatePlane("", {
            width: 0.2,
            height: Math.abs(this.mLineOffset)
        }, this.mScene);
        this.mPickPlaneE.isPickable = true;
        this.mPickPlaneE.position.x = this.getMeasureLength();
        this.mPickPlaneE.position.z = this.mLineOffset * 0.5;
        this.mPickPlaneE.rotation.x = Math.PI / 2;
        this.mPickPlaneE.parent = this.mNode;
        this.mPickPlaneE.position.y = 0.022;
        this.mPickPlane.visibility = 0.0;
        this.mPickPlaneS.visibility = 0.0;
        this.mPickPlaneE.visibility = 0.0;
        //this.mPickPlaneT.visibility = 0.2;
        ShadowGenerator.disableMeshShadow(this.mPickPlane);
        ShadowGenerator.disableMeshShadow(this.mPickPlaneS);
        ShadowGenerator.disableMeshShadow(this.mPickPlaneE);
        //ShadowGenerator.disableMeshShadow(this.mPickPlaneT);
        if (p2d) {
            this.m2dMeshes.push(this.mPickPlane);
            this.m2dMeshes.push(this.mPickPlaneS);
            this.m2dMeshes.push(this.mPickPlaneE);
            //this.m2dMeshes.push(this.mPickPlaneT);
        }
        else {
            this.m3dMeshes.push(this.mPickPlane);
            this.m3dMeshes.push(this.mPickPlaneS);
            this.m3dMeshes.push(this.mPickPlaneE);
            //this.m2dMeshes.push(this.mPickPlaneT);
        }
        this.createText(p2d);
    }
    update2dGeometry() {
        this.createLineSystem(true);
    }
    update3dGeometry() {
        this.createLineSystem(false);
    }
    dispose2dMeshes() {
        if (this.m2dMeshes.length === 0)
            return;
        for (let tMesh of this.m2dMeshes)
            tMesh.dispose();
        this.m2dMeshes = new Array();
    }
    dispose3dMeshes() {
        if (this.m3dMeshes.length === 0)
            return;
        for (let tMesh of this.m3dMeshes)
            tMesh.dispose();
        this.m3dMeshes = new Array();
    }
    static deserialize(pRoomManager, pContext, pIOElement) {
        if (pIOElement == null)
            return (null);
        let tIOMeasure = pIOElement;
        let tMeasure = new Measure(pRoomManager);
        tMeasure.setLineOffset(tIOMeasure.lineOffset);
        tMeasure.setStartPoint(deserializeVector2(tIOMeasure.start));
        tMeasure.setEndPoint(deserializeVector2(tIOMeasure.end));
        tMeasure.updateEdges();
        tMeasure.updateGeometry();
        return (tMeasure);
    }
    setView() {
        let tView = this.mRoomManager.view;
        if (tView != null) {
            tView = tView;
            this.mRoomManager.app.model.scene.onBeforeCameraRenderObservable.add(this.onCameraRender);
            tView.cameraControl.eventCameraChanged.addListener(this.onCameraRender);
        }
        return;
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Measure.PROP_KEY_TEXT = "room:Measure:text";
Measure.PROP_KEY_LENGTH = "room:Measure:length";
Measure.PROP_KEY_LINEDISTANCE = "room:Measure:Distance";
Measure.PROP_KEY_TEXTCHOICE = "room:Measure:textchoice";
Measure.PROP_KEY_COLOR = "room:Measure:color";
Measure.TEXTSCALE = 10;
Measure.LINEENDOFFSET = 0.1;
//// temp variables ////////////////////////////////////////////////////////////////////////////
let gTmpVector2_1 = Vector2.Zero();
